/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useTranslation } from 'react-i18next';
import { getProducts } from '../../../../services/minihub';
import './menu-minihub.scss';

const MenuMinihub = ({ setOpenDialog }) => {
  const { t } = useTranslation();
  const { entradaUsuario, authToken } = useSelector((state) => state.auth);
  const [products, setProducts] = useState([]);
  const menuRef = useRef();

  const onClose = () => {
    setOpenDialog(false);
  };

  const handleClickOutside = (e) => {
    if (e.target.classList.contains('topbar__help-icon')) {
      return;
    }
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenDialog(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getProducts(entradaUsuario, authToken);
        if (result.errors.length === 0) {
          setProducts(result.data.filter((product) => product.indAcceso !== '1'));
        } else {
          const errors = result.errors.join(' ');
          console.error('Error:', errors);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    if (entradaUsuario && authToken) {
      fetchData();
    }
  }, [entradaUsuario, authToken]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={menuRef}>
      <span className="dropdown-menu-minihub-arrow" />
      <div className="menu-minihub-container">
        <div className="content">
          <div className="header">
            <img
              className="lefebvre-ecosistema-logo"
              src="https://assets.lefebvre.es/media/logos/web/comunes/lefebvre-ecosistema-246x40.png"
              alt="lefebvre-ecosistema-logo"
            />
            <button
              type="button"
              className="lf-icon-close"
              onClick={onClose}
              aria-label={t('general_close')}
              title={t('general_close')}
            >
              <span className="sr-only">{t('general_close')}</span>
            </button>
            <div className="menu-title">
              <span>{t('top_bar_minihub_header_title')}</span>
            </div>
          </div>
          <div className="accounts-container menu-main-panel">
            <PerfectScrollbar options={{ suppressScrollX: true }}>
              <div className="menu-header__body-generic">
                <ul className="menu-header__blocks menu-header__blocks--products">
                  {products.map((product) => (
                    <li className="menu-header__block-product ng-scope" key={product.id}>
                      <a
                        className="menu-header__block-icon-product menu-header__block-icon-product--product-1"
                        href={product.url}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={product.descHerramienta}
                        title={product.descHerramienta}
                      >
                        <i className={product.icono} />
                      </a>
                      <div className="menu-header__block-name-product">
                        <span className="ng-binding">{product.descHerramienta}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </PerfectScrollbar>
          </div>
        </div>
      </div>
    </div>
  );
};

MenuMinihub.propTypes = {
  setOpenDialog: PropTypes.func.isRequired,
};

export default MenuMinihub;
